export default function Footer() {
  return (
    <footer id="footer" className="pt-12 md:pt-16 pb-6 px-4 md:px-6 bg-background-950">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-950 text-sm"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-200">八戒电影网</span>
            </div>
            <p className="text-foreground-600 text-xs leading-relaxed">
              八戒电影网是一个专注高清影视资源在线观看的平台。不缓冲流畅播放、无广告快速加载，致力于为影迷提供极致的在线观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-4">快速导航</h4>
            <div className="space-y-2">
              <a href="#hero" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">首页</a>
              <a href="#index" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">精选专题</a>
              <a href="#ranking" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">热门排行</a>
              <a href="#carousel" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">焦点专题</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-4">服务支持</h4>
            <div className="space-y-2">
              <a href="#faq" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">常见问题</a>
              <a href="#contact" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">联系我们</a>
              <a href="#app" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">移动观看</a>
              <a href="#about" className="block text-foreground-600 hover:text-primary-400 text-xs transition-colors cursor-pointer">关于我们</a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-300 mb-4">合作伙伴</h4>
            <p className="text-foreground-700 text-xs leading-relaxed">
              商务合作与资源交换请联系我们，期待与更多优质平台建立合作。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-foreground-700 text-xs">
              &copy; 2019-2026 八戒电影网 bajiemovie.com 保留所有权利
            </p>
            <div className="flex items-center gap-4 text-foreground-700 text-xs">
              <span className="cursor-pointer hover:text-foreground-500 transition-colors">隐私政策</span>
              <span className="cursor-pointer hover:text-foreground-500 transition-colors">服务条款</span>
              <span className="cursor-pointer hover:text-foreground-500 transition-colors">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}